import { MortgageForm } from '../structured/MortgageForm';
import type { ExtractedStructured } from '@/types/extractedTopic';

interface Props {
  value: ExtractedStructured;
  onChange: (next: ExtractedStructured) => void;
  /** Retained for call-site compatibility; MortgageForm sources investors from
   *  the useInvestors hook, so this is no longer consumed here. */
  investorOptions?: string[];
}

/** Structured editor for the extraction-review flow. Reuses the canonical
 *  program editor (MortgageForm) so the import path and the topic editor stay
 *  in lockstep on the nested schema. */
export function StructuredFieldsEditor({ value, onChange }: Props) {
  return <MortgageForm value={value} onChange={onChange} />;
}
